export default __webpack_public_path__ + "static/media/Super.292e72e6.gif";